/**
 * Created by mathieudeumie on 30/04/2014.
 */

angular.module('FlexyBeautyApp.services').
    factory('Partner_Resource',["$resource","$location",
        function ($resource,$location)
        {
            var baseUrl = $location.protocol() + "://" + $location.host() + ($location.port() && ":" + $location.port()) + "/";
            return $resource(baseUrl+'rest/partners/:id',{}, {
                query: { method: 'GET', isArray: true },
                get: { method: 'GET' },
                generateSessionToken : { method: 'POST', url:baseUrl+'rest/partners/generateSessionToken'} ,
            });
        }
    ]);

angular.module('FlexyBeautyApp.services').
    factory('Partner',["Partner_Resource","PartnerData",
        function (Partner_Resource,PartnerData)
        {
            var Partner = function (resource)
            {
                this.id = null;
                this.isDeleted = false;
                this.name = null;
                this.token = null;

                if(resource !== undefined && resource !== null)
                    this.loadObject(resource);

                PartnerData.add(this);
            };

            Partner.prototype.setId = function(id)
            {
                this.id = id;
            };
            Partner.prototype.getId = function()
            {
                return this.id;
            };

            Partner.prototype.loadObject = function(object)
            {
                if (object)
                {
                    if (!this.id)
                        this.id = object.id;
                    /*if (object.timeCreated)
                        this.timeCreated = new Date(object.timeCreated);*/
                    this.isDeleted = object.isDeleted;
                    this.name = object.name;
                    this.token = object.token;
                }
            };


            Partner.prototype.getObjectResource = function(object)
            {
                var newApp = new Partner_Resource();

                newApp.id = this.id;
                newApp.isDeleted = this.isDeleted;
                newApp.name = this.name;
                newApp.token = this.token;

                return newApp;
            }

            return Partner;
        }
    ]);

angular.module('FlexyBeautyApp.services').
    factory('PartnerSrv',["$log","ServerSrv","Partner_Resource","PartnerData","Partner",
        function ($log,ServerSrv,Partner_Resource,PartnerData,Partner)
        {
            var partnerSrv = {};

            partnerSrv.query = function(successFunction,errorFunction)
            {
                Partner_Resource.query(
                    {},
                    function (data) {
                        PartnerData.clear();
                        for(var i=0;i<data.length;i++)
                        {
                            new Partner(data[i]);
                        }

                        if (successFunction!== undefined)
                            successFunction();
                    },
                    function (data) {
                        if (errorFunction !== undefined)
                            errorFunction(data);
                    }
                );
            };
            partnerSrv.restore = function(partner,successFunction,errorFunction)
            {
                PartnerData.restore(partner);
                ServerSrv.startSavingProcess(partnerSrv.restoreSync, partner, successFunction, errorFunction);
            };
            partnerSrv.restoreSync = function(partner,successFunction,errorFunction)
            {
                //$timeout (function () {

                var PartnerRes = partner.getObjectResource();
                PartnerRes.$save({},
                    function (data) {
                        try{
                            partner.setId(data.id);
                            //TODO UserActionData.add(data.userAction);
                            if (successFunction !=undefined)
                                successFunction(data);
                        }
                        finally {
                            ServerSrv.endSavingProcess(true);
                        }
                    },
                    function (data) {   //failure
                        //error handling goes here
                        try {
                            if (errorFunction != undefined)
                                errorFunction(data);
                        }
                        finally {
                            ServerSrv.endSavingProcess(false,(data?data.status:null),(data && data.data?data.data.errorCode:null));
                        }
                    }
                );

                //},2000)
            };
            partnerSrv.save = function(partner,successFunction,errorFunction)
            {
                ServerSrv.startSavingProcess(partnerSrv.saveSync, partner, successFunction, errorFunction);
            };
            partnerSrv.saveSync = function(partner,successFunction,errorFunction)
            {
                var partnerRes = partner.getObjectResource();
                partnerRes.$save({},
                    function (data) {
                        try{
                            partner.setId(data.id);
                            if (successFunction !== undefined)
                                successFunction(data);
                        }
                        finally {
                            ServerSrv.endSavingProcess(true);
                        }
                    },
                    function (data) {   //failure
                        //error handling goes here
                        try{
                            if (errorFunction !== undefined)
                                errorFunction(data);
                        }
                        finally {
                            ServerSrv.endSavingProcess(false,(data?data.status:null),(data && data.data?data.data.errorCode:null));
                        }
                    }
                );
            };
            partnerSrv.remove = function(partner,successFunction,errorFunction)
            {
                PartnerData.remove(partner);
                ServerSrv.startSavingProcess(partnerSrv.removeSync, partner, successFunction, errorFunction);
            };
            partnerSrv.generateSessionToken = function(partner,external,successFunction,errorFunction)
            {
                ServerSrv.startSavingProcess(partnerSrv.generateSessionTokenSync, partner, external,successFunction, errorFunction);
            };
            partnerSrv.generateSessionTokenSync = function(partner,external,successFunction,errorFunction)
            {
                var partnerRes = new Partner_Resource();
                partnerRes.idPartner = partner.id;
                partnerRes.external = external;
                partnerRes.$generateSessionToken({}, //no params
                    function (data) {
                        try{
                            if (successFunction !== undefined)
                                successFunction(data);
                        }
                        finally {
                            ServerSrv.endSavingProcess(true);
                        }
                    },
                    function (data) {
                        //error handling goes here
                        try{
                            if (errorFunction !== undefined)
                                errorFunction(data);
                        }
                        finally {
                            ServerSrv.endSavingProcess(false,(data?data.status:null),(data && data.data?data.data.errorCode:null));
                        }
                    }
                );
            };
            partnerSrv.removeSync = function(partner,successFunction,errorFunction)
            {
                var partnerRes = partner.getObjectResource();
                partnerRes.$remove({id:partner.getId()}, //no params
                    function (data) {
                        try{
                            if (successFunction !== undefined)
                                successFunction(data);
                        }
                        finally {
                            ServerSrv.endSavingProcess(true);
                        }
                    },
                    function (data) {
                        //error handling goes here
                        try{
                            if (errorFunction !== undefined)
                                errorFunction(data);
                        }
                        finally {
                            ServerSrv.endSavingProcess(false,(data?data.status:null),(data && data.data?data.data.errorCode:null));
                        }
                    }
                );
            };

            return partnerSrv;
        }
    ]);

angular.module('FlexyBeautyApp.services').
    factory('PartnerData',["$filter",
        function ($filter)
        {
            var  partnerDataSrv =
            {
                indexPartners : [],
                activePartners : [],
                deletedPartners : []//deleted items
            };
            partnerDataSrv.getById =  function(partnerId)
            {
                for (var i=0;i<this.indexPartners.length;i++)
                    if (this.indexPartners[i].id==partnerId)
                        return this.indexPartners[i];
                return null;
            }
            partnerDataSrv.getByIndex =  function(index)
            {
                if (index>=0 && index <this.indexPartners.length)
                    return this.indexPartners[index];
                return null;
            }
            partnerDataSrv.getIndexOf =  function(partner)
            {
                if (partner)
                    return this.indexPartners.indexOf(partner);
                return -1;
            }

            partnerDataSrv.add =  function(partner)
            {
                var partnerArray = this.activePartners;
                if (partner.isDeleted)
                    partnerArray =  this.deletedPartners;
                var index =  this.indexPartners.indexOf(partner);
                if (index!=-1)
                {
                    var realIndex = partnerArray.indexOf(partner);
                    if (realIndex==-1)
                        partnerArray.push(partner);
                }
                else
                {
                    index = this.indexPartners.length
                    this.indexPartners.push(partner);
                    partnerArray.push(partner);
                }
                return index;
            }
            partnerDataSrv.remove =  function(partner)
            {
                var index =  this.activePartners.indexOf(partner);
                if (index!=-1)
                {
                    this.activePartners.splice(index, 1);
                    this.deletedPartners.push(partner)
                    partner.isDeleted=true;
                }
            }
            partnerDataSrv.restore =  function(partner)
            {
                var index =  this.deletedPartners.indexOf(partner);
                if (index!=-1)
                {
                    this.deletedPartners.splice(index, 1);
                    this.activePartners.push(partner);
                    partner.isDeleted=false;
                }
            }
            partnerDataSrv.clear =  function()
            {
                this.indexPartners = [];
                this.activePartners = [];
                this.deletedPartners = [];
            }
            partnerDataSrv.sort =  function()
            {
                this.activePartners = $filter('orderBy')(this.activePartners,'label', false);
                this.deletedPartners = $filter('orderBy')(this.deletedPartners,'label', false);
            }

            partnerDataSrv.getActiveList =  function()
            {
                return this.activePartners;
            }
            partnerDataSrv.getDeletedList =  function()
            {
                return this.deletedPartners;
            }
            return   partnerDataSrv;
        }
    ]);


// WEBPACK FOOTER //
// ./js/services/models/Partner.js